import { AxiosResponse } from 'axios';
import ApiService from './api.service';
import { BrandEndpoint, BrandAssetEndpoint } from './api.endpoints';
import { BrandWrite } from '../types';

class BrandService extends ApiService {
  async postBrand(payload: BrandWrite): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandEndpoint.CREATE, payload);
    return response;
  }

  async createBrandAsset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandAssetEndpoint.CREATE, payload);
    return response;
  }

  async updateBrand(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandEndpoint.UPDATE, payload);
    return response;
  }

  async updateBrandAsset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandAssetEndpoint.UPDATE, payload);
    return response;
  }

  async fetchBrand(payload: string): Promise<AxiosResponse | undefined> {
    const response = await this.get(BrandEndpoint.GET, { brand_id: payload });
    return response;
  }

  async emailBrandAsset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandAssetEndpoint.SHARE_ASSET, payload);
    return response;
  }

  async createMeeting(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandEndpoint.CREATE_MEETING, payload);
    return response;
  }

  async updateMeeting(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandEndpoint.UPDATE_MEETING, payload);
    return response;
  }

  async deleteBrandAsset(brandAssetId: string): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandAssetEndpoint.DELETE, { brandAssetId });
    return response;
  }

  async fetchBrandForBudtender(
    payload: string,
  ): Promise<AxiosResponse | undefined> {
    const response = await this.get(BrandEndpoint.GET_FOR_BUDTENDER, {
      brand_id: payload,
    });
    return response;
  }
}

export default BrandService;
